import React from "react";
import UseTable from "../../components/table/useTable";
import { useTranslation } from "react-i18next";
import globalStyles from "../../style/global.js";
import useStyles from "./salesStyle";

import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";

import ErrorMessage from "../../components/errorMessage/ErrorMessage";
import CircularProgressBar from "../../components/circularProgress/CircularProgress";

import { Box } from "@mui/material";

import PageTitle from "../../components/pageTitle/PageTitle";

import { getSalesData } from "../../redux/reduser/sales";
function Sales() {
  const { t } = useTranslation();
  const classes = useStyles();
  const globalClasses = globalStyles();
  const { data, loading, error } = useSelector((state) => state.sales);


  
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getSalesData());
  }, []);

  const columns = [
    { name: t("year") },
    { name: t("profitIncrease") },
    { name: t("totalAmount") },
  ];

  return (
    <Box className={globalClasses.background}>
    <Box className={globalClasses.page}>
    <Box className={globalClasses.row}>
     <PageTitle title={t("sales")}/>
   
       
    </Box>
    <Box >
    
      {loading === true ? (
        <div className={globalClasses.center}>
          {" "}
          <CircularProgressBar />{" "}
        </div>
      ) : error == null ? (
        <UseTable
          data={data}
          columns={columns}
          title={t("sales")}
          selectableRows={false}
        />
      ) : (
        <div className={globalClasses.center}>
          {" "}
          <ErrorMessage title={error} />{" "}
        </div>
      )}
    </Box>
    
    </Box>
    </Box>
  );
}
export default Sales;
